type ClassValue = string | false | null | undefined;

/** Joins truthy class strings with a space — a dependency-free stand-in for clsx. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
